import numbOne from '../../../res/numbOne.png';
import numbTwo from '../../../res/numbTwo.png';
import numbThree from '../../../res/numbThree.png';
import numbFour from '../../../res/numbFour.png';
import numbFive from '../../../res/numbFive.png';
import numbSix from '../../../res/numbSix.png';
import numbSeven from '../../../res/numbSeven.png';
import numbEight from '../../../res/numbEight.png';

export const pictures = [
    {
        src: numbOne,
        name: 'chiffre 1',
    },

    {
        src: numbTwo,
        name: 'chiffre 2',
    },

    {
        src: numbThree,
        name: 'chiffre 3',
    },

    {
        src: numbFour,
        name: 'chiffre 4',
    },
    
    {
        src: numbFive,
        name: 'chiffre 5',
    },

    {
        src: numbSix,
        name: 'chiffre 6',
    },

    {
       src: numbSeven,
        name: 'chiffre 7',
    },

    {
        src: numbEight,
        name: 'chiffre 8',
    }
];